import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

type Props = {
  topHalfView: React.ReactNode;
  bottomHalfView: React.ReactNode;
  bottomCollapsed: boolean;
};

export const HalfHalfView = (props: Props): React.ReactElement => {
  const { topHalfView, bottomHalfView, bottomCollapsed } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div
        className={classNames(
          classes.contentContainer,
          classes.topContainer,
          !bottomCollapsed && classes.rootNotCollapsed
        )}
      >
        {topHalfView}
      </div>

      <div
        className={classNames(
          classes.contentContainer,
          classes.bottomContainer,
          !bottomCollapsed && classes.rootNotCollapsed
        )}
      >
        {bottomHalfView}
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      justifyContent: 'space-between',
    },
    topContainer: {
      flex: 'auto',
    },
    bottomContainer: {
      flex: 'none',
    },
    contentContainer: {
      display: 'flex',
      position: 'relative',
      overflow: 'hidden',
    },
    rootNotCollapsed: {
      height: '50%',
    },
  })
);
